import * as React           from "react";

import "./admin-ad-budget-card.scss";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {InlineAmountForm} from "../../../common/inline-amount-form/inline-amount-form";
import {agentDisplay}   from "../admin-ad-budget-card-container";
import {SliderCheckbox}          from "@Common/ui-components/slider-checkbox/slider-checkbox";

export const AdminAdBudgetCard = ({selectedAgents, agent}) => cs(
    consumeContext("apis"),
    ({apis}) => (
        <div className="admin-ad-budget-card-fma19">
            <div className="amount-row">
                <div className="agent-name">
                    {agentDisplay(agent)}
                </div>
                {
                    InlineAmountForm({
                        amount: agent.amount,
                        readOnly: !agent.allow,
                        onChange: (newAmount) => {
                            selectedAgents.change((agents) => agents.map((currentAgent) =>
                                currentAgent.agent.idAgent === agent.agent.idAgent 
                                    ? ({...agent, amount: newAmount})
                                    : currentAgent
                            ))
                            apis.next.adBudgets.setUserAdBudget({
                                idBranch: agent.agent.idBranch,
                                list: [{
                                    idAgent: agent.agent.idAgent,
                                    amount: newAmount,
                                    status: agent.allow,
                                }],
                            })
                        }
                    })
                }
            </div>
            <div className="slider-row">
                {
                    
                    SliderCheckbox({
                        xdQaName: "Slider Checkbox",
                        value: agent.allow,
                        onChange: () => {
                            selectedAgents.change((agents) => agents.map((currentAgent) => 
                                currentAgent.agent.idAgent == agent.agent.idAgent 
                                ? ({...agent, allow: !agent.allow})
                                : currentAgent
                            ))
                            apis.next.adBudgets.setUserAdBudget({
                                idBranch: agent.agent.idBranch,
                                list: [{
                                    idAgent: agent.agent.idAgent,
                                    amount: agent.amount,
                                    status: !agent.allow,
                                }],
                            })
                        },
                    })
                }
                Use this Ad Budget
            </div>            
        </div>
    )
)